import axios from 'axios';

import {
  axiosHeader,
  publicAxiosHeader,
  getV1RootUrl
} from 'common/helpers/apiHelper';

export const listReservations = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId}/reservation?${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId}/reservation`,
    axiosHeader()
  );
};

export const getReservation = (customerId, clubMembershipId) =>
  axios.get(
    `${getV1RootUrl()}/customer/${customerId}/reservation/${clubMembershipId}`,
    axiosHeader()
  );

export const getReservationByEmailReservationNumber = (
  email,
  reservationNumber
) =>
  axios.get(
    `${getV1RootUrl()}/reservation/limited?email=${encodeURIComponent(
      email
    )}&reservationNumber=${reservationNumber}`,
    publicAxiosHeader()
  );
